import { useWindowSizing } from '@app/hooks/useSizeWindow';
import { getListYear, MarkType, ModelType, useGetListYearQuery, YearCurrentType } from '@entities/Auto';

import { Select } from '@ui-kit/Select';
import { useEffect } from 'react';
import { useAppSelector } from '@redux/hooks';
import { useSmartQuery } from '@shared/hooks/useSmartQuery';

const optionsSelect = {
  title: 'Год выпуска',
  name: 'Year',
  dataId: 'select-year',
};

interface SelectYearsProps {
  valueCurrent: YearCurrentType;
  model: ModelType;
  mark: MarkType;
  className?: string;
  classNameValue?: string;
  handlerOnChange: (value: YearCurrentType) => void;
}

export const SelectYears = ({ className, classNameValue, valueCurrent, model, mark, handlerOnChange }: SelectYearsProps) => {
  const isMobile = useWindowSizing(990);
  const ssrData = useAppSelector(getListYear);
  const { data: listYear = [], isFetching } = useSmartQuery({
    queryHook: useGetListYearQuery,
    params: {
      groupCode: model?.groupCode,
      markId: mark?.id,
    },
    isSkip: !mark || !model,
    initialData: ssrData.length ? ssrData : null,
  });

  const handlerSetValueCurrent = (value: string) => {
    if (value === '—') {
      handlerOnChange(null);
    }
    if (value) {
      handlerOnChange(value + '');
    }
  };

  useEffect(() => {
    if (!isFetching && listYear.length === 1 && mark && model) {
      handlerOnChange(listYear[0] + '');
    }
  }, [isFetching, listYear, mark, model]);

  return (
    <Select
      isScrollToSelect
      className={className}
      valueClassName={classNameValue}
      dataTestId={optionsSelect.dataId}
      isLoading={isFetching}
      key={optionsSelect.name}
      readOnly={isMobile}
      label={optionsSelect.title}
      activeValue={valueCurrent?.toString() || '—'}
      dataList={model?.name ? ['—', ...listYear] : ['—']}
      handlerValue={handlerSetValueCurrent}
      disabled={listYear.length < 1 || !model?.name}
    />
  );
};
